// Helper to extract response from attempt, handling both wrapped and unwrapped formats
// Wrapped format (new Grammar): { response: {...} }
// Unwrapped format (old Grammar sessions for backwards compatibility): {...}
export const extractResponse = (attempt: any) => {
  if (!attempt) return attempt;
  return 'response' in attempt ? attempt.response : attempt;
};
